"use strict";
export const TYPES = ["Upcoming", "Past", "Date Range"];
export const FILTERS = [{
  key: "status",
  name: "Status",
  default_text: "Active"
}];
